export const Utils = {
	config: {
		maxPageSize: 65535,
		pageSize: 10,
		enableHome: true,
		development: {
			csosHost: 'preprod-csos.cloudcare.cn',
			apiUrl: '/api',
			// apiUrl: 'https://preprod-csos.cloudcare.cn/api',
			homeApiUrl: 'https://preprod-home.cloudcare.cn/api',
			ccLogout: 'https://preprod-home.prof.wang/issue/list',
			csosTool: 'https://preprod-csos.cloudcare.cn/',
			h5Url: 'https://preprod-h5.cloudcare.cn/',
			litews: 'wss://preprod-csos-lite.cloudcare.cn/api',
			csosws: 'wss://preprod-csos.cloudcare.cn/api',
			agentInstallUrl: 'https://static.cloudcare.cn/cloudlinker/preprod/install.sh',
			backAgentUrl: 'https://static.cloudcare.cn/cloudlinker/preprod',
			databaseReportUrl: 'http://localhost:5175',
		},
		testing: {
			csosHost: 'testing-csos.cloudcare.cn',
			apiUrl: 'http://testing-csos.cloudcare.cn/api',
			homeApiUrl: 'http://testing-home.cloudcare.cn:85/api',
			ccLogout: 'http://testing-profwang-home.cloudcare.cn:10301/issue/list',
			csosTool: 'http://testing-csos.cloudcare.cn/',
			h5Url: 'http://testing-h5.cloudcare.cn:8086/',
			litews: 'ws://120.27.135.41:9527/api',
			csosws: 'ws://testing-csos.cloudcare.cn/api',
			agentInstallUrl: 'http://static.cloudcare.cn/cloudlinker/test/install.sh',
			backAgentUrl: 'http://static.cloudcare.cn/cloudlinker/test',
			databaseReportUrl: 'http://testing-enterprise-report.cloudcare.cn',
		},
		pre: {
			csosHost: 'preprod-csos.cloudcare.cn',
			apiUrl: 'https://preprod-csos.cloudcare.cn/api',
			homeApiUrl: 'https://preprod-home.cloudcare.cn/api',
			ccLogout: 'https://preprod-home.prof.wang/issue/list',
			csosTool: 'https://preprod-csos.cloudcare.cn/',
			h5Url: 'https://preprod-h5.cloudcare.cn/',
			litews: 'wss://preprod-preprod-csos-lite.cloudcare.cn/api',
			csosws: 'wss://preprod-csos.cloudcare.cn/api',
			agentInstallUrl: 'https://static.cloudcare.cn/cloudlinker/preprod/install.sh',
			backAgentUrl: 'https://static.cloudcare.cn/cloudlinker/preprod',
			databaseReportUrl: 'http://preprod-enterprise-report.cloudcare.cn',
		},
		alpha: {
			csosHost: 'csos.prof.wang',
			apiUrl: 'https://csos.cloudcare.cn/api',
			homeApiUrl: 'https://home.prof.wang/api',
			ccLogout: 'https://home.prof.wang/issue/list',
			csosTool: 'https://csos.prof.wang/',
			h5Url: 'https://h5.prof.wang/',
			litews: 'wss://preprod-csos-alpha-lite.cloudcare.cn/api',
			csosws: 'wss://preprod-csos-alpha.cloudcare.cn/api',
			agentInstallUrl: 'https://static.cloudcare.cn/cloudlinker/preprod/alpha/install.sh',
			backAgentUrl: 'https://static.cloudcare.cn/cloudlinker/preprod/alpha',
			databaseReportUrl: 'https://enterprise-report.cloudcare.cn',
		},
		poc: {
			csosHost: 'csos.prof.wang',
			apiUrl: 'https://csos.prof.wang/api',
			homeApiUrl: 'https://home.prof.wang/api',
			ccLogout: 'https://home.prof.wang/issue/list',
			csosTool: 'https://csos.prof.wang/',
			h5Url: 'https://h5.prof.wang/',
			litews: 'wss://csos-lite.prof.wang/api',
			csosws: 'wss://csos.prof.wang/api',
			agentInstallUrl: 'https://static.cloudcare.cn/cloudlinker/poc/install.sh',
			backAgentUrl: 'https://static.cloudcare.cn/cloudlinker/poc',
			databaseReportUrl: 'https://enterprise-report.cloudcare.cn',
		},
		local: {
			csosHost: 'csos-local.cloudcare.cn',
			apiUrl: 'https://csos-local.cloudcare.cn/api',
			homeApiUrl: 'https://preprod-home.cloudcare.cn/api',
			ccLogout: 'https://preprod-home.prof.wang/issue/list',
			csosTool: 'https://csos-local.cloudcare.cn/',
			h5Url: 'https://preprod-h5.cloudcare.cn/',
			litews: 'wss://csos-local-lite.cloudcare.cn/api',
			csosws: 'wss://csos-local.cloudcare.cn/api',
			agentInstallUrl: 'https://static.cloudcare.cn/cloudlinker/local/install.sh',
			backAgentUrl: 'https://static.cloudcare.cn/cloudlinker/local',
			databaseReportUrl: 'https://preprod-enterprise-report.cloudcare.cn',
		},
		production: {
			csosHost: 'csos.cloudcare.cn',
			apiUrl: 'https://csos.cloudcare.cn/api',
			homeApiUrl: 'https://home.cloudcare.cn/api',
			ccLogout: 'https://home.prof.wang/issue/list',
			csosTool: 'https://csos.cloudcare.cn/',
			h5Url: 'https://h5.cloudcare.cn/',
			litews: 'wss://csos-lite.cloudcare.cn/api',
			csosws: 'wss://csos.cloudcare.cn/api',
			agentInstallUrl: 'https://static.cloudcare.cn/cloudlinker/release/install.sh',
			backAgentUrl: 'https://static.cloudcare.cn/cloudlinker/release',
			databaseReportUrl: 'https://enterprise-report.cloudcare.cn',
		},
	},
}

export const baseUrl = Utils.config[process.env.NODE_ENV]
export const enableHome = Utils.config.enableHome

/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */
export function deepCopy(obj, cache = []) {
	// just return if obj is immutable value
	if (obj === null || typeof obj !== 'object') {
		return obj
	}
	// if obj is hit, it is in circular structure
	const hit = find(cache, (c) => c.original === obj)
	if (hit) {
		return hit.copy
	}
	const copy = Array.isArray(obj) ? [] : {}
	// put the copy into cache at first
	// because we want to refer it in recursive deepCopy
	cache.push({
		original: obj,
		copy,
	})
	Object.keys(obj).forEach((key) => {
		copy[key] = deepCopy(obj[key], cache)
	})
	return copy
}
export const Base64 = {
	// private property
	_keyStr: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',

	// public method for encoding
	encode: function (input) {
		var output = ''
		var chr1, chr2, chr3, enc1, enc2, enc3, enc4
		var i = 0

		input = Base64._utf8_encode(input)

		while (i < input.length) {
			chr1 = input.charCodeAt(i++)
			chr2 = input.charCodeAt(i++)
			chr3 = input.charCodeAt(i++)

			enc1 = chr1 >> 2
			enc2 = ((chr1 & 3) << 4) | (chr2 >> 4)
			enc3 = ((chr2 & 15) << 2) | (chr3 >> 6)
			enc4 = chr3 & 63

			if (isNaN(chr2)) {
				enc3 = enc4 = 64
			} else if (isNaN(chr3)) {
				enc4 = 64
			}

			output = output + this._keyStr.charAt(enc1) + this._keyStr.charAt(enc2) + this._keyStr.charAt(enc3) + this._keyStr.charAt(enc4)
		}

		return output
	},

	// private method for UTF-8 encoding
	_utf8_encode: function (string) {
		string = string.replace(/\r\n/g, '\n')
		var utftext = ''

		for (var n = 0; n < string.length; n++) {
			var c = string.charCodeAt(n)

			if (c < 128) {
				utftext += String.fromCharCode(c)
			} else if (c > 127 && c < 2048) {
				utftext += String.fromCharCode((c >> 6) | 192)
				utftext += String.fromCharCode((c & 63) | 128)
			} else {
				utftext += String.fromCharCode((c >> 12) | 224)
				utftext += String.fromCharCode(((c >> 6) & 63) | 128)
				utftext += String.fromCharCode((c & 63) | 128)
			}
		}
		return utftext
	},
}
window.rootVue = window.rootVue
	? window.rootVue
	: {
			$gettext: (t) => {
				return t
			},
	  }
export const SelectOptionsConfig = {
	// used in system-log.vue file
	teamLogs: {
		event: {
			addUser: {
				code: 'addUser',
				text: window.rootVue.$gettext('AddUser'),
			},
			deleteUser: {
				code: 'deleteUser',
				text: window.rootVue.$gettext('DeleteUser'),
			},
			createGroup: {
				code: 'createGroup',
				text: window.rootVue.$gettext('CreateGroup'),
			},
			deleteGroup: {
				code: 'deleteGroup',
				text: window.rootVue.$gettext('DeleteGroup'),
			},
			changePassword: {
				code: 'changePassword',
				text: window.rootVue.$gettext('ChangePassword'),
			},
			addGroupMember: {
				code: 'addGroupMember',
				text: window.rootVue.$gettext('AddGroupMember'),
			},
			deleteGroupMember: {
				code: 'deleteGroupMember',
				text: window.rootVue.$gettext('DeleteGroupMember'),
			},
		},
		role: [
			{
				text: window.rootVue.$gettext('Administrator'),
				val: 'account',
			},
			{
				text: window.rootVue.$gettext('Account Edited'),
				val: 'user',
			},
		],
	},
	clusterLogs: {
		event: {
			createNet: {
				code: 'createNet',
				text: window.rootVue.$gettext('CreateCluster'),
			},
			deleteNet: {
				code: 'deleteNet',
				text: window.rootVue.$gettext('DeleteCluster'),
			},
			addLinuxServer: {
				code: 'addLinuxServer',
				text: window.rootVue.$gettext('AddLinuxServer'),
			},
			deleteLinuxServer: {
				code: 'deleteLinuxServer',
				text: window.rootVue.$gettext('DeleteLinuxServer'),
			},
			addWinServer: {
				code: 'addWinServer',
				text: window.rootVue.$gettext('AddWinServer'),
			},
			deleteWinServer: {
				code: 'deleteWinServer',
				text: window.rootVue.$gettext('DeleteWinServer'),
			},
			addMySQLDatabase: {
				code: 'addMySQLDatabase',
				text: window.rootVue.$gettext('AddMySQLDatabase'),
			},
			deleteMySQLDatabase: {
				code: 'deleteMySQLDatabase',
				text: window.rootVue.$gettext('DeleteMySQLDatabase'),
			},
			addSQLServerDatabase: {
				code: 'addSQLServerDatabase',
				text: window.rootVue.$gettext('AddSQLServerDatabase'),
			},
			deleteSQLServerDatabase: {
				code: 'deleteSQLServerDatabase',
				text: window.rootVue.$gettext('DeleteSQLServerDatabase'),
			},
			shareNet: {
				code: 'shareNet',
				text: window.rootVue.$gettext('ShareCluster'),
			},
			closeSafeMode: {
				code: 'closeSafeMode',
				text: window.rootVue.$gettext('CloseSecurityMode'),
			},
			openSafeMode: {
				code: 'openSafeMode',
				text: window.rootVue.$gettext('OpenSecurityMode'),
			},
			auditSafeMode: {
				code: 'auditSafeMode',
				text: window.rootVue.$gettext('AuditSecurityMode'),
			},
			unauditSafeMode: {
				code: 'unauditSafeMode',
				text: window.rootVue.$gettext('UnauditSecurityMode'),
			},
			addInterceptInstruction: {
				code: 'addInterceptInstruction',
				text: window.rootVue.$gettext('AddInterceptInstruction'),
			},
			removeInterceptInstruction: {
				code: 'removeInterceptInstruction',
				text: window.rootVue.$gettext('RemoveInterceptInstruction'),
			},
			modifySafeModeAuditor: {
				code: 'modifySafeModeAuditor',
				text: window.rootVue.$gettext('ModifySecurityModeAuditor'),
			},
		},
		role: [
			{
				text: window.rootVue.$gettext('Account'),
				val: 'account',
			},
			{
				text: window.rootVue.$gettext('Resource Name'),
				val: 'resource_name',
			},
			{
				text: window.rootVue.$gettext('Cluster Name'),
				val: 'net_name',
			},
			{
				text: window.rootVue.$gettext('Team Name'),
				val: 'shared_company_name',
			},
		],
	},
	resourceLogs: {
		event: {
			addProjectAccount: {
				code: 'addProjectAccount',
				text: window.rootVue.$gettext('AddWorkgroupAccount'),
			},
			deleteProjectAccount: {
				code: 'deleteProjectAccount',
				text: window.rootVue.$gettext('DeleteWorkgroupAccount'),
			},
			addProjectAdmin: {
				code: 'addProjectAdmin',
				text: window.rootVue.$gettext('AddWorkgroupAdmin'),
			},
			deleteProjectAdmin: {
				code: 'deleteProjectAdmin',
				text: window.rootVue.$gettext('DeleteWorkgroupAdmin'),
			},
			addProjectGroup: {
				code: 'addProjectGroup',
				text: window.rootVue.$gettext('AddWorkgroupGroup'),
			},
			deleteProjectGroup: {
				code: 'deleteProjectGroup',
				text: window.rootVue.$gettext('DeleteWorkgroupGroup'),
			},
			deleteProject: {
				code: 'deleteProject',
				text: window.rootVue.$gettext('DeleteWorkgroup'),
			},
			createProject: {
				code: 'createProject',
				text: window.rootVue.$gettext('CreateWorkgroup'),
			},
			addLinuxServerToProject: {
				code: 'addLinuxServerToProject',
				text: window.rootVue.$gettext('AddLinuxServerToWorkgroup'),
			},
			removeLinuxServerFromProject: {
				code: 'removeLinuxServerFromProject',
				text: window.rootVue.$gettext('RemoveLinuxServerFromWorkgroup'),
			},
			removeWinServerFromProject: {
				code: 'removeWinServerFromProject',
				text: window.rootVue.$gettext('RemoveWinServerFromWorkgroup'),
			},
			addWinServerToProject: {
				code: 'addWinServerToProject',
				text: window.rootVue.$gettext('AddWinServerToWorkgroup'),
			},
			addMySQLDatabaseToProject: {
				code: 'addMySQLDatabaseToProject',
				text: window.rootVue.$gettext('AddMySQLDatabaseToWorkgroup'),
			},
			removeMySQLDatabaseFromProject: {
				code: 'removeMySQLDatabaseFromProject',
				text: window.rootVue.$gettext('RemoveMySQLDatabaseFromWorkgroup'),
			},
			addSQLServerDatabaseToProject: {
				code: 'addSQLServerDatabaseToProject',
				text: window.rootVue.$gettext('AddSQLServerDatabaseToWorkgroup'),
			},
			removeSQLServerDatabaseFromProject: {
				code: 'removeSQLServerDatabaseFromProject',
				text: window.rootVue.$gettext('RemoveSQLServerDatabaseFromWorkgroup'),
			},
		},
		role: [
			{
				text: window.rootVue.$gettext('Account'),
				val: 'account',
			},
			{
				text: window.rootVue.$gettext('Workgroup Name'),
				val: 'project_name',
			},
			{
				text: window.rootVue.$gettext('Resource Name'),
				val: 'resource_name',
			},
			{
				text: window.rootVue.$gettext('Account Edited'),
				val: 'project_account',
			},
		],
	},
	alarmLogs: {
		event: {
			addProjectAccount: {
				code: 'addProjectAccount',
				text: window.rootVue.$gettext('AddWorkgroupAccount'),
			},
			deleteProjectAccount: {
				code: 'deleteProjectAccount',
				text: window.rootVue.$gettext('DeleteWorkgroupAccount'),
			},
			addProjectAdmin: {
				code: 'addProjectAdmin',
				text: window.rootVue.$gettext('AddWorkgroupAdmin'),
			},
			deleteProjectAdmin: {
				code: 'deleteProjectAdmin',
				text: window.rootVue.$gettext('DeleteWorkgroupAdmin'),
			},
			addProjectGroup: {
				code: 'addProjectGroup',
				text: window.rootVue.$gettext('AddWorkgroupGroup'),
			},
			deleteProjectGroup: {
				code: 'deleteProjectGroup',
				text: window.rootVue.$gettext('DeleteWorkgroupGroup'),
			},
			deleteProject: {
				code: 'deleteProject',
				text: window.rootVue.$gettext('DeleteWorkgroup'),
			},
			createProject: {
				code: 'createProject',
				text: window.rootVue.$gettext('CreateWorkgroup'),
			},
			addLinuxServerToProject: {
				code: 'addLinuxServerToProject',
				text: window.rootVue.$gettext('AddLinuxServerToWorkgroup'),
			},
			removeLinuxServerFromProject: {
				code: 'removeLinuxServerFromProject',
				text: window.rootVue.$gettext('RemoveLinuxServerFromWorkgroup'),
			},
			removeWinServerFromProject: {
				code: 'removeWinServerFromProject',
				text: window.rootVue.$gettext('RemoveWinServerFromWorkgroup'),
			},
			addWinServerToProject: {
				code: 'addWinServerToProject',
				text: window.rootVue.$gettext('AddWinServerToWorkgroup'),
			},
			addMySQLDatabaseToProject: {
				code: 'addMySQLDatabaseToProject',
				text: window.rootVue.$gettext('AddMySQLDatabaseToWorkgroup'),
			},
			removeMySQLDatabaseFromProject: {
				code: 'removeMySQLDatabaseFromProject',
				text: window.rootVue.$gettext('RemoveMySQLDatabaseFromWorkgroup'),
			},
			addSQLServerDatabaseToProject: {
				code: 'addSQLServerDatabaseToProject',
				text: window.rootVue.$gettext('AddSQLServerDatabaseToWorkgroup'),
			},
			removeSQLServerDatabaseFromProject: {
				code: 'removeSQLServerDatabaseFromProject',
				text: window.rootVue.$gettext('RemoveSQLServerDatabaseFromWorkgroup'),
			},
			createNet: {
				code: 'createNet',
				text: window.rootVue.$gettext('CreateCluster'),
			},
			deleteNet: {
				code: 'deleteNet',
				text: window.rootVue.$gettext('DeleteCluster'),
			},
			addLinuxServer: {
				code: 'addLinuxServer',
				text: window.rootVue.$gettext('AddLinuxServer'),
			},
			deleteLinuxServer: {
				code: 'deleteLinuxServer',
				text: window.rootVue.$gettext('DeleteLinuxServer'),
			},
			addWinServer: {
				code: 'addWinServer',
				text: window.rootVue.$gettext('AddWinServer'),
			},
			deleteWinServer: {
				code: 'deleteWinServer',
				text: window.rootVue.$gettext('DeleteWinServer'),
			},
			addMySQLDatabase: {
				code: 'addMySQLDatabase',
				text: window.rootVue.$gettext('AddMySQLDatabase'),
			},
			deleteMySQLDatabase: {
				code: 'deleteMySQLDatabase',
				text: window.rootVue.$gettext('DeleteMySQLDatabase'),
			},
			addSQLServerDatabase: {
				code: 'addSQLServerDatabase',
				text: window.rootVue.$gettext('AddSQLServerDatabase'),
			},
			deleteSQLServerDatabase: {
				code: 'deleteSQLServerDatabase',
				text: window.rootVue.$gettext('DeleteSQLServerDatabase'),
			},
			shareNet: {
				code: 'shareNet',
				text: window.rootVue.$gettext('ShareCluster'),
			},
			closeSafeMode: {
				code: 'closeSafeMode',
				text: window.rootVue.$gettext('CloseSecurityMode'),
			},
			openSafeMode: {
				code: 'openSafeMode',
				text: window.rootVue.$gettext('OpenSecurityMode'),
			},
			auditSafeMode: {
				code: 'auditSafeMode',
				text: window.rootVue.$gettext('AuditSecurityMode'),
			},
			unauditSafeMode: {
				code: 'unauditSafeMode',
				text: window.rootVue.$gettext('UnauditSecurityMode'),
			},
			addInterceptInstruction: {
				code: 'addInterceptInstruction',
				text: window.rootVue.$gettext('AddInterceptInstruction'),
			},
			removeInterceptInstruction: {
				code: 'removeInterceptInstruction',
				text: window.rootVue.$gettext('RemoveInterceptInstruction'),
			},
			modifySafeModeAuditor: {
				code: 'modifySafeModeAuditor',
				text: window.rootVue.$gettext('ModifySecurityModeAuditor'),
			},
			addProjectAccount: {
				code: 'addProjectAccount',
				text: window.rootVue.$gettext('AddWorkgroupAccount'),
			},
			deleteProjectAccount: {
				code: 'deleteProjectAccount',
				text: window.rootVue.$gettext('DeleteWorkgroupAccount'),
			},
			addProjectAdmin: {
				code: 'addProjectAdmin',
				text: window.rootVue.$gettext('AddWorkgroupAdmin'),
			},
			deleteProjectAdmin: {
				code: 'deleteProjectAdmin',
				text: window.rootVue.$gettext('DeleteWorkgroupAdmin'),
			},
			addProjectGroup: {
				code: 'addProjectGroup',
				text: window.rootVue.$gettext('AddWorkgroupGroup'),
			},
			deleteProjectGroup: {
				code: 'deleteProjectGroup',
				text: window.rootVue.$gettext('DeleteWorkgroupGroup'),
			},
			deleteProject: {
				code: 'deleteProject',
				text: window.rootVue.$gettext('DeleteWorkgroup'),
			},
			createProject: {
				code: 'createProject',
				text: window.rootVue.$gettext('CreateWorkgroup'),
			},
			addLinuxServerToProject: {
				code: 'addLinuxServerToProject',
				text: window.rootVue.$gettext('AddLinuxServerToWorkgroup'),
			},
			removeLinuxServerFromProject: {
				code: 'removeLinuxServerFromProject',
				text: window.rootVue.$gettext('RemoveLinuxServerFromWorkgroup'),
			},
			removeWinServerFromProject: {
				code: 'removeWinServerFromProject',
				text: window.rootVue.$gettext('RemoveWinServerFromWorkgroup'),
			},
			addWinServerToProject: {
				code: 'addWinServerToProject',
				text: window.rootVue.$gettext('AddWinServerToWorkgroup'),
			},
			addMySQLDatabaseToProject: {
				code: 'addMySQLDatabaseToProject',
				text: window.rootVue.$gettext('AddMySQLDatabaseToWorkgroup'),
			},
			removeMySQLDatabaseFromProject: {
				code: 'removeMySQLDatabaseFromProject',
				text: window.rootVue.$gettext('RemoveMySQLDatabaseFromWorkgroup'),
			},
			addSQLServerDatabaseToProject: {
				code: 'addSQLServerDatabaseToProject',
				text: window.rootVue.$gettext('AddSQLServerDatabaseToWorkgroup'),
			},
			removeSQLServerDatabaseFromProject: {
				code: 'removeSQLServerDatabaseFromProject',
				text: window.rootVue.$gettext('RemoveSQLServerDatabaseFromWorkgroup'),
			},
		},
		role: [
			{
				text: window.rootVue.$gettext('Users'),
				val: 'account_name',
			},
			{
				text: window.rootVue.$gettext('Source IP'),
				val: 'source_ip',
			},
			{
				text: window.rootVue.$gettext('Operation Obj'),
				val: 'resource_name',
			},
			{
				text: window.rootVue.$gettext('Event Desc'),
				val: 'command',
			},
		],
	},
}

export const ClusterRegionConfig = [
	{
		localName: window.rootVue.$gettext('China East 1(Hangzhou)'),
		regionId: 'cn-hangzhou',
	},
	{
		localName: window.rootVue.$gettext('China East 2(Shanghai)'),
		regionId: 'cn-shanghai',
	},
	{
		localName: window.rootVue.$gettext('China South 1(Shenzhen)'),
		regionId: 'cn-shenzhen',
	},
	{
		localName: window.rootVue.$gettext('China North 1(Qingdao)'),
		regionId: 'cn-qingdao',
	},
	{
		localName: window.rootVue.$gettext('China North 2(Beijing)'),
		regionId: 'cn-beijing',
	},
	{
		localName: window.rootVue.$gettext('Hong Kong'),
		regionId: 'cn-hongkong',
	},
	{
		localName: window.rootVue.$gettext('Asia Pacific SE 1(Singapore)'),
		regionId: 'ap-southeast-1',
	},
	{
		localName: window.rootVue.$gettext('US East 1(Virginia)'),
		regionId: 'us-east-1',
	},
	{
		localName: window.rootVue.$gettext('US West 1(Silicon Valley)'),
		regionId: 'us-west-1',
	},
]

// The Aliyun Official Image Which We Support for cluster-check-support file
export const ClusterAliyunSupport = [
	{
		os: 'CentOS',
		version: '7.0 64bit',
		comment: '',
	},
	{
		os: 'CentOS',
		version: '6.5 64bit',
		comment: '',
	},
	{
		os: 'Debian',
		version: '7.5.0 64bit',
		comment: window.rootVue.$gettext('Curl must be installed'),
	},
	{
		os: 'Debian',
		version: '6.0.9 64bit',
		comment: window.rootVue.$gettext('Curl must be installed'),
	},
	{
		os: 'ubuntu',
		version: '14.04 64bit',
		comment: window.rootVue.$gettext('Curl must be installed'),
	},
	{
		os: 'ubuntu',
		version: '12.04 64bit',
		comment: window.rootVue.$gettext('Curl must be installed'),
	},
]

export const PasswordStrengthMessage = {
	0: '',
	1: window.rootVue.$gettext('The password strength requirement is: the password length is lowest 6 bits , must contain two of uppercase letters, lowercase letters, and special characters.'),
	2: window.rootVue.$gettext('The password strength requirement is: the password length is lowest 8 bits, must contain uppercase letter, lowercase letter, special character.'),
}

export const PasswordStrengthRegExp = {
	uppercasePattern: /[A-Z]/,
	lowercasePattern: /[a-z]/,
	sysbolPattern: /[ !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~\\]/,
}

export const PasswordStrengthRegExpCallback = {
	level1_msg: window.rootVue.$gettext('The password must be at least 6 characters long and must contain two uppercase letters, lowercase letters, and special characters.'),
	level2_msg: window.rootVue.$gettext('The password must be at least 8 characters long and must contain uppercase letters, lowercase letters, and special characters.'),
}



// WEBPACK FOOTER //
// ./src/config.js